import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { ExpandingFAQ, FrequentlyAskedQuestionsContainer } from './FrequentlyAskedQuestions';
import { getAcademyUrlPublic, getCommunityUrlPublic, getKnowledgeBaseUrlPublic, getLanguagesUrlPublic, getMarketingUrlPublic, getNonProfitsUrlPublic, getStartupsUrlPublic } from './FrequentlyAskedQuestionsPublicPageUrls';
import { handleClickFrequentlyAskedQuestionLink } from './trackFrequentlyAskedQuestions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const communityHref = getCommunityUrlPublic();
const langHref = getLanguagesUrlPublic();
const academyHref = getAcademyUrlPublic();
const kbHref = getKnowledgeBaseUrlPublic();
const marketingHref = getMarketingUrlPublic();
const startupsHref = getStartupsUrlPublic('pricing-marketingpage');
const nonprofitsHref = getNonProfitsUrlPublic('pricing-marketingpage');
export const MarketingHubFaqs = () => {
  return /*#__PURE__*/_jsxs(FrequentlyAskedQuestionsContainer, {
    children: [/*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatIsMarketing.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatIsMarketing.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          marketingLink: /*#__PURE__*/_jsx(Link, {
            href: marketingHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'marketing.whatIsMarketing',
                url: marketingHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatIsMarketing.learnMore"
            })
          })
        }
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatAreMarketingContacts.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatAreMarketingContacts.answer"
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.howManyContacts.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.howManyContacts.answer"
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.howManyEmails.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.howManyEmails.answer"
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.marketingRequiredOnboarding.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.marketingRequiredOnboarding.answer"
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatSupport.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatSupport.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          communityLink: /*#__PURE__*/_jsx(Link, {
            href: communityHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'marketing.whatSupport',
                url: communityHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatSupport.hubSpotCommunity"
            })
          }),
          languageLink: /*#__PURE__*/_jsx(Link, {
            href: langHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'marketing.whatSupport',
                url: langHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatSupport.languageOffering"
            })
          }),
          academyLink: /*#__PURE__*/_jsx(Link, {
            href: academyHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'marketing.whatSupport',
                url: academyHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatSupport.hubSpotAcademy"
            })
          }),
          kbLink: /*#__PURE__*/_jsx(Link, {
            href: kbHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'marketing.whatSupport',
                url: kbHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatSupport.hubSpotKnowledgeBase"
            })
          })
        }
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatDiscounts.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatDiscounts.answer",
        options: {
          startupsLink: /*#__PURE__*/_jsx(Link, {
            href: startupsHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'marketing.whatDiscounts',
                url: startupsHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatDiscounts.hubSpotForStartups"
            })
          }),
          nonprofitsLink: /*#__PURE__*/_jsx(Link, {
            href: nonprofitsHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'marketing.whatDiscounts',
                url: nonprofitsHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.marketing.whatDiscounts.hubSpotForNonprofits"
            })
          })
        }
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whenEligibleForNewPricing.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.marketing.whenEligibleForNewPricing.answer"
      })
    })]
  });
};